export default __webpack_public_path__ + "static/media/food1.4d518892.jpeg";